const {
  GET_STAFF,
  GET_STAFF_ERROR,
  STAFF_UPDATE,
  STAFF_UPDATE_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_STAFF:
    case STAFF_UPDATE:
      return {
        ...state,
        data: payload,
        loading: false,
        error: null,
      };
    case GET_STAFF_ERROR:
    case STAFF_UPDATE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
